<template>
    <div class="row" :class="{'flex-column-reverse': editView}">
        <div class="col">
            <UploadImage 
                type="logo" 
                @setImage = "setImage" 
                :default-image = "logo"
                max-size="3"
                :required-error = "`${errors['missing-logo'] ? 'Please add a logo' : ''}`"
                >
                <template v-slot:content>
                    <Icon icon="heart-purple" class="m-0" />
                    <p class="mb-0 mt-1 d-block c1 eina-semibold">Upload Your Logo*</p>
                </template>
            </UploadImage>
            <UploadImage 
                class="mt-3" 
                @setImage = "setImage" 
                :default-image = "cover" 
                max-size="10"
                :required-error = "`${errors['missing-cover'] ? 'Please add a cover image' : ''}`"
                >
                <template v-slot:content>
                    <Icon icon="upload-image" class="my-2" />
                    <p class="m-0 d-block c1 eina-semibold">Upload Cover Image*</p>
                    <span class="c24 lab">JPG, PNG</span>
                </template>
            </UploadImage>
            
        </div>

        <div class="shop-info" :class="{'col-7': !editView, 'col': editView}">
            <div v-if="editView">
                <EditableField :initial-value = "title" type = "title" @setInfo = "setTitle" :max-length="100">
                    <p class="text-center error-text mt-1 ml-1 tlabb" v-if="errors['empty-title'] && !title">Please fill out the title</p>
                </EditableField>
                <EditableField :initial-value = "description" type = "description" @setInfo = "setDescription" class="mb-4">
                    <p class="text-center error-text mt-1 ml-1 tlabb" v-if="errors['empty-description'] && !description">Please fill out the description</p>
                </EditableField>
            </div>
            <div style="margin-top: -3px;" v-else>
                <div class="form-field-holder position-relative">
                    <p class="field-label">Shop Name*</p>
                    <md-field id="shop-title-field" class="pt-0">
                        <md-input
                            class="pt-2 w-100 c24 form-field"
                            v-model.trim="title"
                            maxlength="100"
                            placeholder="Shop Name*"/>
                    </md-field>
                    <p class="error-text mt-0 mb-0 ml-1 position-absolute" v-if="errors['empty-title'] && !title">Fill out this field</p>
                </div>
                <div class="form-field-holder position-relative">
                    <p class="field-label">Description*</p>
                    <md-field id="shop-description-field" class="pt-0">
                        <md-textarea
                            class="pt-2 w-100 c24 form-field"
                            v-model.trim="description"
                            maxlength="500"
                            placeholder="Shop Description*"/>
                    </md-field>
                    <p class="error-text mt-0 mb-0 ml-1 position-absolute" v-if="errors['empty-description'] && !description">Fill out this field</p>
                </div>
                <div class="form-field-holder">
                    <p class="field-label">Add your products as tags, separated by commas.</p>
                    <md-chips
                        id="shop-tags"
                        class="shop-tags"
                        :class = "{'md-error': tagsErrorText}"
                        md-outlined
                        md-placeholder="Types of Products..."
                        :md-limit="5"
                        :md-format="tagsValidation"
                        v-model="tags">
                    </md-chips>
                    <p class="error-text">{{tagsErrorText}}</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Thumbnail from '../Theme/Thumbnail'
import Icon from '../Theme/Icon'
import EditableField from '../Theme/EditableField'
import {validateUploading} from "../../core/_validateUploading";
import UploadImage from './UploadImage'
import {useErrors} from '../../core/hooks'
import {ref, onMounted} from '@vue/composition-api'

export default {
    name: 'EditShopProfile',
    props: {
        data: Object,
        editView: Boolean,
    },
    components: {
        Icon,
        Thumbnail,
        UploadImage,
        EditableField
    },
    setup(props, {emit}){

        const errorHandler = useErrors();
        const errors = useErrors().messages;

        const tags = ref(props.data.tags || [])
        const logo = ref(props.data.logo || null) 
        const cover = ref(props.data.cover || null) 
        const tagsErrorText = ref('')
        const uploadingCover = ref(null) 
        const uploadingError = ref(null) 
        const description = ref(props.data.description || '')
        const title = ref(props.data.title || '')

        const setImage = (image) => {
            if(image.type === 'logo') {
                logo.value= image.url
                errorHandler.setError('missing-logo', false)
                emit('setData', {
                    ...props.data,
                    logo: logo.value
                })
                return
            }
            cover.value= image.url
            emit('setData', {
                ...props.data,
                cover: cover.value
            })
            errorHandler.setError('missing-cover', false)
        }

        const setTitle = value => {
            title.value = value

            emit('setData', {
                ...props.data,
                title: title.value
            })
        }

        const setDescription = value => {
            description.value = value

            emit('setData', {
                ...props.data,
                description: description.value
            })
        }

        const setData = value => {
            const data = {
                 ...props.data,
                description: description.value,
                logo: logo.value,
                cover: cover.value,
            }

            if(!props.editView) {
                data.tags = tags.value
            }

            emit('setData', data)
        }

        const validateFields = () => {

            if(!props.editView) {
                errorHandler.resetErrors()
            }

            if(!title.value){
                errorHandler.setError('empty-title', true)
            }

            if(!description.value){
                errorHandler.setError('empty-description', true)
            }


            if(!logo.value){
                errorHandler.setError('missing-logo', true)
            }

            if(!cover.value){
                errorHandler.setError('missing-cover', true)
            }

            if(errorHandler.hasError()){
                return
            }

            setData()
        }

        const tagsValidation = (value) =>  {
            if(value.length > 16) {
                tagsErrorText.value = "You've reached the character limit per tag"
                return 
            }
            tagsErrorText.value = ""
            return value
        }

        return {
            errors,
            tags,
            logo, 
            cover,
            setTitle,
            setDescription,
            validateFields,
            tagsErrorText,
            tagsValidation,
            description,
            title,
            setImage,
            setData
        }
    }
}
</script>

<style lang="scss">

    .form-field-holder .md-field {
        margin: 0;
    }

    .shop-tags {
        .md-chip {
            background: #F4F7FA;
            border: 1px solid #E2E8F0;
            box-sizing: border-box;
            border-radius: 4px;
            font-size: 14px;
            margin-left: 0;
            margin-right: 4px;

            &+.md-chip {
                margin-left: 0;
            }
        }
    }

    .shop-tags.md-field.md-theme-default {
        &:before, &:after{
            height: 0;
            background: none;
            display: none;
        }
    }
    

    .shop-info .md-field.md-chips {
        border: 1px solid #CBD5E0;
        border-radius: 4px;
        padding: 12px 16px;
    }

    #shop-description-field, #shop-title-field{
        flex-direction: column;
        align-items: flex-end;
        .md-count {
            position: static;
        }
    }


    #edit-description, #edit-title {
        &.md-field.md-has-textarea:not(.md-autogrow) .md-count {
            right: 0;
            bottom: -22px;
        }
    }

</style>

<style lang="scss" scoped>
    #shop-description-field,  #shop-title-field{
        textarea {
            min-height: 164px;
        }

        .form-field {
            border: 1px solid #CBD5E0!important;
            border-radius: 4px;
            padding: 12px 16px;
            resize: auto!important;
            color: #718096!important;
            -webkit-text-fill-color: #718096;
        }

        

        &:before, &:after {
            content: none!important;
        }
    }


    #logo-dragover {
        width: 100%;
        height: 88px;
        border: 10px solid #f4f7fa;
        background-repeat: no-repeat;
        border-radius: 8px;
        background-size: 100% 100%;
        background-image: url('/img/upload֊shop-logo.png')
    }

    #img-dragover {
        width: 100%;
        margin-top: 12px;
        border: 10px solid #f4f7fa;
        height: 176px;
        background-repeat: no-repeat;
        border-radius: 8px;
        background-size: 100% 100%;
        background-image: url('/img/upload-shop-image.png')
    }

    .image-label {
        cursor: pointer;
        border-radius: 8px;
    }

    #logo {
        width: 30px;
    }

    .field-label {
        font-size: 14px;
        margin-bottom: 8px;
        padding-left: 2px;
    }

    .form-field-holder {
        margin-bottom: 5px;
    }

    .form-field-holder .error-text {
        bottom: -2px;
    }

</style>